<template lang="pug">
.row.mx-0.py-1.category-group
  .scrolling-wrapper
    template(v-if="menu1 == 'mmoparlay'")
      .category.active
        .sport-icon 
          img(:src="'/images/icon-sport-svg/1.svg?v=12'")
        .sport-name {{ sports[1] }}
    template(v-else)
      template(v-for="n in order")
        .category(:key="n" v-if="items[n]" @click="showSelected(n)" :class="{ 'active' : selectedSportType == n }")
          .live(v-if="live[n] && live[n].tn > 0") {{ $t("ui.live") }}
          .sport-icon(v-if="n == 41")
            img(:src="'/images/icon-sport-svg/' + n + '.png?v=12'" style="height: 28px; width: 18px; margin-top: -4px;")
          .sport-icon(v-else)
            img(:src="'/images/icon-sport-svg/' + n + '.svg?v=12'")
          .sport-name {{ sports[n] }}
          .event-count {{ items[n].tn }}
</template>

<script>
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";
import naming from "@/library/_name.js";

export default {
  props: {
    mode: {
      type: Number
    },
    order: {
      type: Array,
      default: () => []
    },
    items: {
      type: Object,
      default: () => {}
    },
    live: {
      type: Object,
      default: () => {}
    },
    today: {
      type: Object,
      default: () => {}
    },
    sports: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      options: {}
    };
  },
  computed: {
    selectedSportType() {
      return this.menu2;
    },
    selectedSportName() {
      return this.sports[this.menu2];
    },
    selectedCount() {
      if (this.items != null && this.items[this.menu2] != null && this.items[this.menu2].hasOwnProperty("tn")) {
        return this.items[this.menu2].tn;
      } else {
        return 0;
      }
    },
    lang() {
      return this.$store.getters.language;
    },
    menu0() {
      return this.$store.getters.menu0;
    },
    menu1() {
      return this.$store.getters.menu1;
    },
    menu2() {
      return this.$store.getters.menu2;
    },
    menu3() {
      return this.$store.getters.menu3;
    },
    isOutrightEmpty() {
      return this.today[this.menu2] != null && this.today[this.menu2].hasOwnProperty("orz") && this.today[this.menu2].orz <= 0;
    }
  },
  mounted() {
    this.initial();
  },
  methods: {
    getSportsImage(e) {
      return e == 0 ? "all.svg?v=12" : config.getSportsImage(e);
    },
    initial() {
      var sportsList = Object.keys(this.items);
      if (!sportsList.includes(this.menu2.toString())) {
        if (sportsList.length > 0) {
          var x = sportsList[0];
          if(this.mode) {
            this.showSelected(x);
          }
        }
      }
    },
    showSelected(e) {
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      // mi5["src"] = "showSelected";
      mi5["menu0"] = this.menu0;
      mi5["menu1"] = this.menu1;
      // mi5["menu4"] = this.menu4;
      mi5["menu2"] = parseInt(e);      
      mi5["menu3"] = this.menu3;
      // if(this.menu1 == 'live'){
      for (var n in this.options) {
        this.options[n] = false;
      }
      this.options[e] = true;
      this.$emit("save", Object.assign({}, this.options));
      // }
      this.$store.dispatch("layout/setMenuItems", mi5);
      EventBus.$emit("INVALIDATE", mi5);
      // console.log(this.isOutright)
      // if(this.menu3 == 'orz' && this.isOutrightEmpty) {
      //   mi5["menu3"] = "hdpou";
      //   this.$store.dispatch("layout/setMenuItems", mi5);
      //   EventBus.$emit("INVALIDATE", mi5);
      // }
    }
  }
};
</script>
